import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DownloadHeatmapCommand, IHeatmapReportClient, HeatmapReportClient } from "app/ApiClient";
import { BASE_URL } from "const/baseUrl";

const reportClient: IHeatmapReportClient = new HeatmapReportClient(BASE_URL);
const downloadReport = createAsyncThunk("reports/download", async (arg: DownloadHeatmapCommand) => {
  const heatmap = await reportClient.downloadHeatmap(arg);
  return heatmap;
});

export interface DownloadReportState {
  loading: "idle" | "pending" | "succeeded" | "failed";
}

const initialState = {
  loading: "idle",
} as DownloadReportState;

const downloadReportSlice = createSlice({
  name: "downloadReport",
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder.addCase(downloadReport.pending, () => {});

    builder.addCase(downloadReport.fulfilled, () => {});
  },
});

export default downloadReportSlice.reducer;
